/**
 * Footer -- Pied de page du portfolio.
 *
 * Role : afficher les liens sociaux (LinkedIn, GitHub, GitLab), le copyright
 * dynamique (annee courante calculee au runtime), et eventuellement des
 * liens secondaires (mentions legales, RGPD, etc. -- pas encore utilises).
 *
 * `currentYear` : calcule via `new Date().getFullYear()` -> l'annee du
 * copyright reste toujours a jour sans intervention manuelle.
 *
 * Donnees : les URLs sociales sont hardcodees. Migreront vers l'API si un
 * jour on veut permettre a l'owner de les mettre a jour depuis le BO
 * (Sprint 004+).
 */

import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer footer-center p-4 bg-base-300 text-base-content">
      <div>
        <p>Copyright © {currentYear} - Tous droits réservés</p>
      </div>
    </footer>
  );
};

export default Footer;
